import { Instance } from 'mobx-state-tree'
import { TodayCommunityGamesModelBase } from './TodayCommunityGamesModel.base'

/* The TypeScript type of an instance of TodayCommunityGamesModel */
export interface TodayCommunityGamesModelType extends Instance<typeof TodayCommunityGamesModel.Type> {}

/* A graphql query fragment builders for TodayCommunityGamesModel */
export {
  selectFromTodayCommunityGames,
  todayCommunityGamesModelPrimitives,
  TodayCommunityGamesModelSelector
} from './TodayCommunityGamesModel.base'

/**
 * TodayCommunityGamesModel
 */
export const TodayCommunityGamesModel = TodayCommunityGamesModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
